import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { useAdminPeople, type AdminPersonRow } from './api';
import { DataTable, DataTableShell, Pagination, DASH, formatTimestamp } from './shared';
import { connectedAgentLabel, signupOriginLabel } from './identity';
import { UserDrawer } from './UserDrawer';

const PAGE_SIZE = 50;
export function PeopleTable() {
  const [q,setQ]=useState('');
  const [offset,setOffset]=useState(0);
  const [params,setParams]=useSearchParams();
  const {data,isLoading,error}=useAdminPeople({q:q.trim() || undefined,limit:PAGE_SIZE,offset});
  const rows=data?.data ?? [];
  const setDrawer=(id: string | null)=>{ const next=new URLSearchParams(params); if(id) next.set('id',id); else next.delete('id'); next.delete('tab');setParams(next,{replace:true}); };
  // Old team/lead bookmarks must not open a user drawer under a foreign ID.
  const drawerId=['agents','leads','handles'].includes(params.get('tab') ?? '') ? null : params.get('id');
  return <div className="space-y-4">
    <Input placeholder="Search handle or email…" value={q} onChange={event=>{setQ(event.target.value);setOffset(0);}} />
    <DataTableShell loading={isLoading} error={error} empty={!rows.length}>
      <DataTable<AdminPersonRow> rows={rows} rowKey={row=>row.id} onRowClick={row=>{if(row.user_id)setDrawer(row.user_id);}} columns={[
        {key:'handle',label:'Handle',render:r=>r.prediction_handle ?? DASH},
        {key:'email',label:'Email',render:r=>r.email ?? DASH},
        {key:'identity',label:'Identity',render:r=>r.identity_kind==='unfinished_lead' ? 'Unfinished lead' : 'Account'},
        {key:'verified',label:'Email verified',render:r=>r.email ? r.email_verified ? 'Yes' : 'No' : DASH},
        {key:'origin',label:'Signup origin',render:r=>r.user_id ? signupOriginLabel(r.created_via) : 'Not recorded'},
        {key:'auth',label:'Earliest recorded auth',render:r=><span title="First recorded successful authentication, not proof of signup provider.">{r.first_auth_provider ?? DASH}</span>},
        {key:'created',label:'Created',render:r=><span title={r.user_id ? 'Account record created' : 'First recorded email request'}>{formatTimestamp(r.created_at)}</span>},
        {key:'last_seen',label:'Last seen',render:r=><span title="Latest recorded account/team update or authentication activity; not an online heartbeat.">{formatTimestamp(r.last_seen_at)}</span>},
        {key:'grants',label:'Agent authorization',render:r=><span title="Usable current MCP/API grants, not team records or online status.">{connectedAgentLabel(r.connected_agent_count)}</span>},
        {key:'model',label:'Self-reported model',render:r=><span title={r.self_reported_model_reported_at ? `Self-reported ${formatTimestamp(r.self_reported_model_reported_at)}` : 'Client declaration; not verified.'}>{modelLabel(r)}</span>},
      ]}/>
      <Pagination total={data?.meta.total ?? 0} limit={PAGE_SIZE} offset={offset} onChange={setOffset}/>
    </DataTableShell>
    <UserDrawer userId={drawerId} onClose={()=>setDrawer(null)}/>
  </div>;
}
function modelLabel(row: AdminPersonRow) {
  if(row.self_reported_model_status==null) return 'Not available';
  if(row.self_reported_model_status==='unwilling') return 'Not disclosed';
  if(row.self_reported_model_status==='unknown') return 'Unknown';
  if(row.self_reported_model_status==='not_reported') return 'Not reported';
  return [row.self_reported_model,row.self_reported_provider].filter(Boolean).join(' · ') || 'Unknown';
}
